const zh_cn = {
    'hkidr.uploadconsent':'香港投资者识别码制度及场外证券交易汇报制度表格*',
    'hkidr.donwloadconsent':'下载表格 (按此)',

    'hkidr.accountId':'帐户号码',
    'hkidr.accountName':'帐户名称 (英文)',
    'hkidr.hkidr':'香港投资者识别码资料',
    'hkidr.idDoc':'您的身分证明文件',
    'hkidr.idNo': '您的身分证明文件号码',
    'hkidr.docType':'档案类型',
    'hkidr.doc':'上载文件',
    'hkidr.HKID':'香港身份证',    
    'hkidr.PP':'护照',
    'hkidr.CONSENT':'香港投资者识别码制度及场外证券交易汇报制度表格',
    'hkidr.NTID':'国民身分证',
    'hkidr.NTIDF':'上载文件(正面)',
    'hkidr.NTIDB':'上载文件(背面)',
    'hkidr.OTH':'其他',
    'hkidr.':' ',
    'hkidr.accountNo': '帐户号码',
    'hkidr.accName': '帐户名称',
    'hkidr.invalidIssuePlace':'签发地点无效',
    'hkidr.uploadFileNotice': '本人/吾等需要更新客户识别信息，并向凯基亚洲提供最新的身分证明文件副本(如适用)',
    'hkidr.jointAccUploadFileNotice': '请选择档案类型及文件后按〝添加〞键。如多于一个档案须提交，请重复此步骤。',    
    'hkidr.invalidDocType':'档案类型无效',
    'hkidr.invalidFile':'档案无效',
    'hkidr.invalidAcc':'帐户号码无效',
    'hkidr.invalidConsent':'确认无效',
    'hkidr.invalideSignature':'电子签署无效',    
    'hkidr.browse':'浏览',
    'hkidr.add':'添加',
    "hkidr.concentdesp": "我/我们同意及接受以下条款:",
    "hkidr.tc": "条款 12345678",
    'general.notes': '注',
    'general.submit': '提交',
    'hkidr.captcha':'验证码',
    'general.formAuth':'KGI eForm Auth',
    'hkidr.idIssuePlace': '签发地点',
    'hkidr.remark1':'客户必须于客户同意书及身分证明文件副本(如适用)上签署，否则我们可能会不接受阁下的指示。 ',
    'hkidr.remark2':'在本表格上载客户的身分证明文件，会一并用于更新您的帐户资料。 ',
    'hkidr.remark3':'项目标有*号者必需填写，否则我们可能会不接受阁下的指示。 ',
    'hkidr.remark4':'请于香港工作天下午四时正前提交本表格。在工作天截止时间后或是在星期六、日及公众假期递交的客户指示将在随后的一个工作天办理。',
    'hkidr.eSignature':"电子签署",
    'hkidr.requestUpdate':"更新身分证明文件",
    'hkidr.yes':"是",
    'hkidr.no':"否",
    'general.confirmation':'确认',
    'general.cancel':'取消',
    'general.ok':'提交',
    'general.close':'关闭',
    'hkidr.fileinstruction':'请于上载客户的身分证明文件副本(正面)前于该副本下方签名。',
    'hkidr.sample':'样本',
    'hkidr.result':'结果',
    'hkidr.success':'提交成功',
    'hkidr.fail':'提交失败. 请重新输入或联络您的营业代表。',
    'hkidr.LEI':'法律实体识别编码(LEI)登记文件',
    'hkidr.COI':'公司注册证明书',
    'hkidr.BRC':'商业登记证',
    'hkidr.OTHS':'其他同等文件',
    'hkidr.maxexceed': '已达上载文件上限',
    'hkidr.verifyErr_1':' ',
    'hkidr.verifyErr_0':' ',
    'hkidr.verifyErr_-1':'验证码无效',
    'hkidr.verifyErr_-2':'请输入正确的帐户号码及帐户名称(英文)',
    'hkidr.verifyErr_-3':'请输入正确的帐户号码及帐户名称(英文)',
    'hkidr.verifyErr_-4':'验证失败 ,请联络您的营业代表。',
    'hkidr.consented':'感谢使用凯基电子服务,您的资料已提交。',
    'hkidr.invalidFileType':'档案无效: 只支援档案类型 jpg/gif/png/pdf',
    'hkidr.invalidFileSize':'档案无效: 档案大小超过10MB',
};
export default zh_cn;